/**
 * Extracts a human-readable error message from an API error response.
 *
 * Handles common formats:
 * - `{ detail: "..." }`
 * - `{ message: "..." }`
 * - `{ error: "..." }`
 * - `{ phone_number: ["Error text"] }` — field-level validation errors
 * - Plain string
 */
export function extractErrorMessage(
  data: unknown,
  fallback = "Something went wrong",
): string {
  if (!data) return fallback;
  if (typeof data === "string") return data;

  if (typeof data === "object" && data !== null) {
    const obj = data as Record<string, unknown>;
    if (typeof obj.detail === "string") return obj.detail;
    if (typeof obj.message === "string") return obj.message;
    if (typeof obj.error === "string") return obj.error;

    for (const value of Object.values(obj)) {
      if (Array.isArray(value) && value.length > 0 && typeof value[0] === "string")
        return value[0];
      if (typeof value === "string") return value;
    }
  }

  return fallback;
}
